<template>
    <section class="section_contact containerg">
        <div class="title_desc_contact">
            <div class="title_contact">{{ $t('contact_us') }}</div>
            <div class="desc_contact">{{ $t('contact_us_desc') }}</div>
        </div>
        <div class="boxuri_contact">
            <div class="boxcontact">
                <a href="tel:0747247876" class="icon_contact"><i class="ri-phone-line"></i></a>
                <div class="box_right_contact">
                    <a href="tel:0747247876" class="boxtitle">{{ $t('telefon') }}</a>
                    <div class="boxdetalii"><a style="color:#fff;" href="tel:0747247876">0747247876</a></div>
                </div>
            </div>
            <div class="boxcontact">
                <a href = "mailto: suport@tikibistro.ro" class="icon_contact"><i class="ri-mail-line"></i></a>
                <div class="box_right_contact">
                    <a href = "mailto: suport@tikibistro.ro" class="boxtitle">Email</a>
                    <a href = "mailto: suport@tikibistro.ro" class="boxdetalii">suport@tikibistro.ro</a>
                </div>
            </div>
        </div>
        <div class="contact_inputs">
            <div class="form_group margin_right_18px">
                <input type="text" class="input_form nume" name="nume" :placeholder="$t('nume_contact')"   v-model="nume">
            </div>
            <div class="form_group margin_left_18px">
                <input type="text" class="input_form email" name="email" placeholder="Email"  v-model="email">
            </div>
            <div class="form_group_total">
                <input type="text" class="input_form mesaj" name="mesaj" :placeholder="$t('mesaj_contact')"  v-model="mesaj" >
            </div>
            <label class="checkbox_termeni container">
                <div class="de_acord">{{$t('politica_de_confidentialitate')}}</div>
                <input type="checkbox" v-model="de_acord">
                <span class="checkmark"></span>
            </label>
            <div v-if="nume && email && mesaj && de_acord == true" @click="trimite_contact" class="send_contact send_contact_activ">{{ $t('send') }}</div>
            <div v-else class="send_contact">{{ $t('send') }}</div>
            
        </div>
        
        
    </section>
</template>


<script>
  import axios from 'axios';
    import Vue from 'vue';
    import VueFilterDateFormat from 'vue-filter-date-format';
      import $ from 'jquery'

    Vue.use(VueFilterDateFormat);
    export default {
        metaInfo() {
            return { 
                title: "Contact | Tiki Bistro | Livrări și take-away",
                meta: [
                    { name: 'description', content:  'Ai întrebări, nelămuriri sau vrei să rezervi o masă? Nu ezita să ne contactezi la 0747.247.876 sau completând formularul de aici.'},
                    { property: 'og:title', content: "Contact | Tiki Bistro | Livrări și take-away"},
                    { property: 'og:description', content: 'Ai întrebări, nelămuriri sau vrei să rezervi o masă? Nu ezita să ne contactezi la 0747.247.876 sau completând formularul de aici.'},
                    { property: 'og:site_name', content: 'Tiki Bistro'},
                    {property: 'og:type', content: 'website'},    
                    {name: 'robots', content: 'index,follow'} 
                ]
            }
        },
        data() {
            return {
                nume : '',
                email: '',
                mesaj : '',
                de_acord : '',
            }
    }, 
    methods: {
        trimite_contact: function() {
            axios.post('https://xpanel.tikibistro.ro/api/contact', {
                name: this.nume,
                email: this.email,
                message_title : this.mesaj,
                message : this.mesaj,
            },{
                headers: {
                  "Access-Control-Allow-Origin" : "*",
                },
                withCredentials: false,
              })
            .then((response) => {
                 console.log(response);
                 this.nume='';
                 this.email='';
                 this.mesaj ='';
                 this.mesaj = '';
                 this.de_acord = false;
                 if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                        $('.contact_trimis').animate({ "right": "10px"}, "slow");
                    } else{
                        $('.contact_trimis').animate({ "right": "20px"}, "slow");
                    }
                    setTimeout(function(){
                    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                        $('.contact_trimis').animate({"right": "-1000px"}, "slow");
                    } else{
                        $('.contact_trimis').animate({"right": "-100vw"}, "slow");
                    }
                    }, 2000);
                
            }, (error) => {
            console.log(error);
            }); 
        }
    },
    mounted() {
        
    },
    
   
  }
</script>

